module.exports = __webpack_public_path__ + "img/recent_transactions.924fe0e3.svg";